import React from "react";
import { Box } from "@chakra-ui/react";
import { useDraggable } from "../useDraggable";
import { SHAPES } from "../boardTools";

const STROKE = 2;

/**
 * A drawn shape, as SVG so it scales cleanly and the outline stays 2px at any
 * size. The four shapes differ only in the element inside the same box, which
 * is why one component covers them all.
 */
const ShapeItem = ({ item, isSelected, readOnly, onMove, onSelect }) => {
  const { onPointerDown } = useDraggable({
    x: item.x, y: item.y, onMove, onStart: onSelect, disabled: readOnly,
  });

  const w = Math.max(item.width, 1);
  const h = Math.max(item.height, 1);
  const inset = STROKE / 2;

  const geometry = {
    [SHAPES.LINE]: <line x1={0} y1={h} x2={w} y2={0} />,
    [SHAPES.SQUARE]: (
      <rect x={inset} y={inset} width={Math.max(w - STROKE, 0)} height={Math.max(h - STROKE, 0)} rx={4} />
    ),
    [SHAPES.TRIANGLE]: (
      <polygon points={`${w / 2},${inset} ${w - inset},${h - inset} ${inset},${h - inset}`} />
    ),
    [SHAPES.CIRCLE]: (
      <ellipse cx={w / 2} cy={h / 2} rx={Math.max(w / 2 - inset, 0)} ry={Math.max(h / 2 - inset, 0)} />
    ),
  }[item.shape];

  return (
    <Box
      position="absolute"
      left={`${item.x}px`}
      top={`${item.y}px`}
      width={`${w}px`}
      height={`${h}px`}
      cursor={readOnly ? "default" : "grab"}
      _active={{ cursor: readOnly ? "default" : "grabbing" }}
      onPointerDown={onPointerDown}
      borderRadius="6px"
      // Selection is drawn by the frame around it, not by the shape.
    >
      <svg
        width={w}
        height={h}
        viewBox={`0 0 ${w} ${h}`}
        fill="none"
        stroke={item.colour}
        strokeWidth={STROKE}
        strokeLinecap="round"
        strokeLinejoin="round"
        style={{ display: "block", overflow: "visible" }}
      >
        {geometry}
      </svg>
    </Box>
  );
};

export default ShapeItem;
